// Global logger utility that can be disabled in production
// Usage: logger.log('message', data) instead of console.log
import { CONFIG, FEATURES } from "@/config";

class Logger {
  private enabled: boolean;

  constructor() {
    // Only enable logs in development or if explicitly enabled
    this.enabled = CONFIG.IS_DEVELOPMENT || FEATURES.ENABLE_API_LOGS;
  }

  log(...args: any[]) {
    if (this.enabled) {
      console.log(...args);
    }
  }

  warn(...args: any[]) {
    if (this.enabled) {
      console.warn(...args);
    }
  }

  error(...args: any[]) {
    // Always show errors, even in production
    console.error(...args);
  }

  info(...args: any[]) {
    if (this.enabled) {
      console.info(...args);
    }
  }

  debug(...args: any[]) {
    if (this.enabled) {
      console.log("🔍", ...args);
    }
  }

  // Group methods for better organization
  group(...args: any[]) {
    if (this.enabled) {
      console.group(...args);
    }
  }

  groupEnd() {
    if (this.enabled) {
      console.groupEnd();
    }
  }

  // Production-safe method that always returns nothing
  prod(...args: any[]) {
    // Never logs, even in dev - for temporary debugging only
  }
}

export const logger = new Logger();

// Also export as default for convenience
export default logger;
